/* unplugin-vue-components disabled */import { render } from "./contactUs.vue?vue&type=template&id=1da88dd4&scoped=true"
import script from "./contactUs.vue?vue&type=script&lang=js"
export * from "./contactUs.vue?vue&type=script&lang=js"

import "./contactUs.vue?vue&type=style&index=0&id=1da88dd4&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da88dd4"]])

export default __exports__